(() => {
  const setup = (root) => {
    if (!root || root.dataset.scafReady === 'true') return;
    root.dataset.scafReady = 'true';

    const variantSelect = root.querySelector('[data-scaf-variant-select]');
    const ticketPrice = root.querySelector('[data-scaf-price]');
    const addButton = root.querySelector('[data-scaf-add-button]');

    if (variantSelect && ticketPrice && addButton) {
      const syncVariant = () => {
        const option = variantSelect.options[variantSelect.selectedIndex];
        const isAvailable = option?.dataset.available === 'true';
        ticketPrice.textContent = option?.dataset.price || ticketPrice.textContent;
        addButton.disabled = !isAvailable;
        addButton.textContent = isAvailable ? 'Add ticket to cart' : 'Sold out';
      };

      variantSelect.addEventListener('change', syncVariant);
      syncVariant();
    }

    const mobileBooking = root.querySelector('[data-scaf-mobile-booking]');
    const hero = root.querySelector('.scaf-hero');
    const booking = root.querySelector('[data-scaf-booking]');

    if (mobileBooking && hero && booking && 'IntersectionObserver' in window) {
      let heroVisible = true;
      let bookingVisible = false;

      const syncMobileBooking = () => {
        mobileBooking.hidden = heroVisible || bookingVisible;
      };

      const heroObserver = new IntersectionObserver(([entry]) => {
        heroVisible = entry.isIntersecting;
        syncMobileBooking();
      }, { threshold: 0.08 });

      const bookingObserver = new IntersectionObserver(([entry]) => {
        bookingVisible = entry.isIntersecting;
        syncMobileBooking();
      }, { threshold: 0.08 });

      heroObserver.observe(hero);
      bookingObserver.observe(booking);
    }
  };

  const setupAll = (scope = document) => {
    scope.querySelectorAll('[data-scaf-root]').forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll());
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
})();
